import { Button } from "@/components/ui/button";
import ThemeToggle from "./ThemeToggle";
import medgrowthIcon from "@/assets/medgrowth-icon.png";

interface NavbarProps {
  onWaitlistClick: () => void;
}

const Navbar = ({ onWaitlistClick }: NavbarProps) => {
  return (
    <nav className="fixed top-8 md:top-0 left-0 right-0 z-50 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-2.5">
          <img src={medgrowthIcon} alt="MedGrowth" width={32} height={32} className="h-8 w-8 object-contain" />
          <a href="https://radar.medgrowthpartners.net/" target="_blank" rel="noopener noreferrer" className="text-lg font-bold tracking-tight hover:opacity-80 transition-opacity">
            MedGrowth <span className="brand-gradient-text">Radar</span>
          </a>
        </div>
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Button size="sm" onClick={onWaitlistClick}>
            Join the Waitlist
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;